<script setup lang="ts">
import { computed, ref } from 'vue'
import { NModal } from 'naive-ui'
import General from './General.vue'
import { useAuthStore } from '@/store'

interface Props {
  visible: boolean
}

interface Emit {
  (e: 'update:visible', visible: boolean): void
}

const props = defineProps<Props>()

const emit = defineEmits<Emit>()

const authStore = useAuthStore()

const isChatGPTAPI = computed<boolean>(() => !!authStore.isChatGPTAPI)

const active = ref('General')

const show = computed({
  get() {
    return props.visible
  },
  set(visible: boolean) {
    emit('update:visible', visible)
  },
})
</script>

<template>
  <NModal v-model:show="show" :auto-focus="false" preset="card" style="width: 95%; max-width: 640px" title="Config System">
    <General />

    <!--    <div> -->
    <!--      <NTabs v-model:value="active" type="line" animated> -->
    <!--        <NTabPane name="General" tab="General"> -->
    <!--          <div class="min-h-[100px]"> -->
    <!--          </div> -->
    <!--        </NTabPane> -->
    <!--        <NTabPane v-if="isChatGPTAPI" name="Advanced" tab="Advanced"> -->
    <!--          <SvgIcon class="text-lg" icon="ri:equalizer-line" /> -->
    <!--          <span class="ml-2">{{ $t('setting.advanced') }}</span> -->
    <!--          <div class="min-h-[100px]"> -->
    <!--            <Advanced /> -->
    <!--          </div> -->
    <!--        </NTabPane> -->
    <!--      </NTabs> -->
    <!--    </div> -->
  </NModal>
</template>
